angular.module 'app'
.controller 'SynonymCtrl', ($rootScope, $scope, $http, $stateParams, $state, $location, config, Storage, SweetAlert, dialogs, growl, FileUploader) ->
  return $state.go 'app.wechat' if Storage.get('user_permission').interaction.smartService.is_use == false

  $scope.ui =
    permission: Storage.get('user_permission')
    isLoading: false
    totalItems: 0
    currentPage: 1
    perPage: 10
    maxSize: 6
    appmsgs: []
    rebuild: ''
    search:
      text: ''
    status: ''
    last_rebuild_time: ''
    choseTesters: []

  findDatas = ->
    $scope.ui.isLoading = true
    $http.get "#{config.api.baseUrl}/dsi/synonym?access_token=" + Storage.get('access_token'),
      params:
        synonym: $scope.ui.search.text
        limit: $scope.ui.perPage
        offset: ($scope.ui.currentPage - 1) * $scope.ui.perPage
        sort: "-updated_at"
        status: $scope.ui.status
    .then (res) ->
      _.each res.data.data, (data) ->
        data.updated_at = moment(data.updated_at).format('YYYY-MM-DD')
        data.status = '新增' if data.status == 'create'
        data.status = '已修改' if data.status == 'update'
        data.status = '已刪除' if data.status == 'delete'
      $scope.ui.appmsgs = res.data.data
      $scope.ui.rebuild = res.data.rebuild
      $scope.ui.totalItems = res.data.count
      $scope.ui.last_rebuild_time = moment(res.data.last_rebuild_time.prod).format('YYYY-MM-DD HH:mm') if res.data.last_rebuild_time.prod
      $scope.ui.isLoading = false
    .catch (error) ->
      if error.data.error.indexOf('errtext') >= 0
        err = JSON.parse error.data.error
        growl.error err.errtext
      else
        growl.error('網絡連接失敗，請稍後重試')

  findTesters = ->
    $scope.ui.isLoading = true
    $http.get "#{config.api.baseUrl}/dsi/qa-tester?access_token=" + Storage.get('access_token'),
      params:
        original_id: $stateParams.original_id
    .then (res) ->
      $scope.ui.choseTesters = res.data.is_add
      $scope.ui.isLoading = false
    .catch (error) ->
      if error.data.error.indexOf('errtext') >= 0
        err = JSON.parse error.data.error
        growl.error err.errtext
      else
        growl.error('網絡連接失敗，請稍後重試')

  findTesters()
  $scope.$watch 'ui.currentPage', findDatas

  #添加
  $scope.add = ->
    dlg = dialogs.create('apps/smartService/add/addSynonym', 'AddSynonymCtrl', {appmsg: ''}, {size: 'lg'})
    dlg.result.then ((option) ->
      findDatas()
      return if option == 'Cancel'
    ), ->

  #修改
  $scope.editDetail = (appmsg) ->
    dlg = dialogs.create('apps/smartService/add/addSynonym', 'AddSynonymCtrl', {appmsg: appmsg}, {size: 'lg'})
    dlg.result.then ((option) ->
      findDatas()
      return if option == 'Cancel'
    ), ->

  #刪除
  $scope.delAppmsg = (appmsg) ->
    SweetAlert.swal {
      title: "你確定嗎?"
      text: "是否確定刪除“#{appmsg.synonym}”?"
      type: "warning"
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      cancelButtonText: '取消'
      confirmButtonText: '確定'
    }, (isConfirm) ->
      if isConfirm
        $http.delete "#{config.api.baseUrl}/dsi/synonym/#{appmsg._id}?access_token=" + Storage.get('access_token'), {}
        .then (res) ->
          findDatas()
        .catch (error) ->
          if error.data.error.indexOf('errtext') >= 0
            err = JSON.parse error.data.error
            growl.error err.errtext
          else
            growl.error('網絡連接失敗，請稍後重試')

  #重跑模型
  $scope.rebuildModel = ->
    return if $scope.ui.rebuild.prod == false && $scope.ui.rebuild.test == false
    dlg = dialogs.create('apps/smartService/rebuild/rebuildModel', 'RebuildModelCtrl', {synonym: 'synonym', last_rebuild_time: $scope.ui.last_rebuild_time, rebuild: $scope.ui.rebuild, choseTesters: $scope.ui.choseTesters}, {size: 'lg'})
    dlg.result.then ((option) ->
      findDatas()
      return if option == 'Cancel'
    ), ->

  $scope.searchText = ->
    $scope.ui.totalItems = 0
    $scope.ui.currentPage = 1
    $scope.ui.appmsgs = []
    findDatas()

  # 按下 Enter 鍵查詢
  $scope.keyUp = (e) ->
    keycode = if window.event then e.keyCode else e.which
    if keycode == 13
      $scope.ui.totalItems = 0
      $scope.ui.currentPage = 1
      $scope.ui.appmsgs = []
      findDatas()

  $scope.statusNormal = ->
    $scope.ui.totalItems = 0
    $scope.ui.currentPage = 1
    $scope.ui.status = ''
    findDatas()

  $scope.statusUnusual = ->
    $scope.ui.totalItems = 0
    $scope.ui.currentPage = 1
    $scope.ui.status = 'no_normal'
    findDatas()
